module.exports = __webpack_public_path__ + "static/media/image1.80917330.png";